import type {TimelineRegion} from './TimelineRegion';

class TimedMetadata {
    public regions: TimelineRegion[] = [];
}

export {TimedMetadata};
